import { useSelector } from "react-redux";

export const useCustomTheme = () => {
    const globalTheme = useSelector(state => state.Theme);

    return globalTheme;
}

export const useAppName = () => {
    const globalTheme = useSelector(state => state.Theme);

    return globalTheme.appName || "BaxRx";
}